/* eslint-disable react/jsx-curly-newline */
import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useParams, useHistory } from 'react-router-dom';
import {
  CRow,
  CCol,
  CCard,
  CCardHeader,
  CCardBody,
  CCardFooter,
  CFormGroup,
  CLabel,
  CInput,
  CButton,
  CForm,
  CInputCheckbox,
  CInputFile,
} from '@coreui/react';
import { useDispatch, useSelector } from 'react-redux';

import 'react-confirm-alert/src/react-confirm-alert.css';
import { resetData } from 'src/slices/NewsItemSlice';
import apiClient from 'src/api/api-client';
import { uploadFileURI } from 'src/api';
import { detailCompany, upsertCompany } from 'src/slices/CompanySlice';
import { useTrans } from 'src/contexts/language';

const CompanyDetail = () => {
  const { t, language } = useTrans();
  const routeParams = useParams();
  const { id } = routeParams;
  const [openModalProject, setOpenModalProject] = useState(false);
  const [selectedLogo, setSelectedLogo] = useState();
  const [selectedImage, setSelectedImage] = useState();
  const companyItem = useSelector(state => state.companyItem);
  const dispatch = useDispatch();
  const history = useHistory();
  const [validated, setValidated] = useState(false);

  const formik = useFormik({
    initialValues: {
      language,
      name_vi: companyItem.name_vi || '',
      name_en: companyItem.name_en || '',
      name_jp: companyItem.name_jp || '',
      status: companyItem.status || 0,
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      name_vi: Yup.string().required(`${t('Vui lòng điền')} ${t('Tên tiếng')} ${t('Việt')}`),
    }),
    onSubmit: async vals => {
      let { image, logo } = companyItem;
      if (selectedImage) {
        const uploadFormData = new FormData();
        uploadFormData.append('file', selectedImage);
        const uploadRes = await apiClient.handleRequest({
          method: 'post',
          url: `${uploadFileURI}`,
          data: uploadFormData,
        });
        image = uploadRes.data.data;
      }
      if (selectedLogo) {
        const uploadFormData = new FormData();
        uploadFormData.append('file', selectedLogo);
        const uploadRes = await apiClient.handleRequest({
          method: 'post',
          url: `${uploadFileURI}`,
          data: uploadFormData,
        });
        logo = uploadRes.data.data;
      }

      const res = await dispatch(
        upsertCompany({
          id: id === 'create' ? '' : id,
          data: { ...vals, image, logo },
        }),
      );
      if (res.payload === true) {
        history.push(`/company`);
      }
    },
  });
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    touched,
    setFieldValue,
    values, // use this if you want controlled components
    errors,
    initialValues,
  } = formik;
  const imageChange = e => {
    setSelectedImage(e.target.files[0]);
  };
  const logoChange = e => {
    setSelectedLogo(e.target.files[0]);
  };

  const setData = (name, value) => {
    setFieldValue(name, value);
  };

  const handleClean = e => {
    e.preventDefault();
    dispatch(resetData());
    setSelectedImage();
    history.push(`/company`);
  };

  useEffect(() => {
    (async () => {
      if (id !== 'create') {
        await dispatch(detailCompany(id));
      } else {
        dispatch(resetData());
        setSelectedImage();
      }
    })();
  }, [id]);

  return (
    <>
      <CForm
        action=""
        method="post"
        encType="multipart/form-data"
        className="form-horizontal"
        onSubmit={handleSubmit}
      >
        <CCard>
          <CCardHeader>{t('Tạo mới nhà cung cấp')}</CCardHeader>
          <CCardBody>
            <CRow>
              <CCol xs="6">
                <CFormGroup>
                  <CLabel htmlFor="name_vi">
                    {t('Tên tiếng')} {t('Việt')}
                  </CLabel>
                  <CInput
                    id="name_vi"
                    name="name_vi"
                    onChange={e => setData(e.target.name, e.target.value)}
                    value={values.name_vi || ''}
                  />
                  {touched.name_vi && errors.name_vi ? (
                    <small className="text-danger">{t(errors.name_vi)}</small>
                  ) : null}
                </CFormGroup>
              </CCol>
              <CCol xs="6">
                <CFormGroup>
                  <CLabel htmlFor="name_en">
                    {t('Tên tiếng')} {t('Anh')}
                  </CLabel>
                  <CInput
                    id="name_en"
                    name="name_en"
                    onChange={e => setData(e.target.name, e.target.value)}
                    value={values.name_en || ''}
                  />
                  {touched.name_en && errors.name_en ? (
                    <small className="text-danger">{t(errors.name_en)}</small>
                  ) : null}
                </CFormGroup>
              </CCol>
              <CCol xs="6">
                <CFormGroup>
                  <CLabel htmlFor="name_vi">
                    {t('Tên tiếng')} {t('Nhật')}
                  </CLabel>
                  <CInput
                    id="name_jp"
                    name="name_jp"
                    onChange={e => setData(e.target.name, e.target.value)}
                    value={values.name_jp || ''}
                  />
                  {touched.name_jp && errors.name_jp ? (
                    <small className="text-danger">{t(errors.name_jp)}</small>
                  ) : null}
                </CFormGroup>
              </CCol>
            </CRow>

            <CRow>
              <CCol xs="6">
                <CFormGroup>
                  <CLabel htmlFor="logo">{t('Tải')} logo</CLabel>
                  <CFormGroup variant="custom-checkbox">
                    <CInputFile
                      custom
                      id="logo"
                      onChange={e => {
                        logoChange(e);
                      }}
                      accept="image/*"
                    />
                    <CLabel htmlFor="logo" variant="custom-file">
                      {selectedLogo?.name || t('Chọn file')}
                    </CLabel>
                  </CFormGroup>
                </CFormGroup>
              </CCol>
              <CCol xs="6">
                <CFormGroup>
                  <CLabel htmlFor="image">{t('Tải')} banner</CLabel>
                  <CFormGroup variant="custom-checkbox">
                    <CInputFile
                      custom
                      id="image"
                      onChange={e => {
                        imageChange(e);
                      }}
                      accept="image/*"
                    />
                    <CLabel htmlFor="image" variant="custom-file">
                      {selectedImage?.name || t('Chọn file')}
                    </CLabel>
                  </CFormGroup>
                </CFormGroup>
              </CCol>
            </CRow>

            <CRow>
              <CCol xs="6">
                {selectedLogo && (
                  <div>
                    <img
                      style={{ width: '-webkit-fill-available' }}
                      src={URL.createObjectURL(selectedLogo)}
                      alt=""
                    />
                  </div>
                )}
                {!selectedLogo && companyItem.logo && (
                  <div>
                    <img
                      style={{ width: '-webkit-fill-available' }}
                      src={companyItem.logo}
                      alt=""
                    />
                  </div>
                )}
              </CCol>
              <CCol xs="6">
                {selectedImage && (
                  <div>
                    <img
                      style={{ width: '-webkit-fill-available' }}
                      src={URL.createObjectURL(selectedImage)}
                      alt=""
                    />
                  </div>
                )}
                {!selectedImage && companyItem.image && (
                  <div>
                    <img
                      style={{ width: '-webkit-fill-available' }}
                      src={companyItem.image}
                      alt=""
                    />
                  </div>
                )}
              </CCol>
            </CRow>
            <CRow>
              <CCol xs="4">
                <CFormGroup variant="custom-checkbox" inline>
                  <CInputCheckbox
                    id="status"
                    name="status"
                    checked={values.status ? 1 : 0}
                    onChange={e => setData(e.target.name, values.status ? 0 : 1)}
                  />
                  <CLabel htmlFor="status">{t('Kích hoạt')}</CLabel>
                </CFormGroup>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter align="center">
            <CButton color="primary" style={{ marginRight: 10 }} type="submit">
              {t('Lưu')}
            </CButton>
            <CButton color="secondary" onClick={handleClean}>
              {t('Không')}
            </CButton>
          </CCardFooter>
        </CCard>
      </CForm>
      <style>
        {`
          .horizontal-slider {
            width: 100%;
            max-width: 700px;
            height: 10vh;
            margin: auto;
          }
          .horizontal-text {
            max-width: 700px;
            width: 100%;
            margin: auto;
            display: flex;
            justify-content: space-between;
          }
          .horizontal-text div {
            text-align: center;
          }
          .horizontal-text p {
            background-color: #fca432;
            padding: 7px;
            color: white;
            border-radius: 15px;
          }
          .example-thumb {
            cursor: pointer;
            position: absolute;
            z-index: 100;
            background: #ffffff;
            border: 5px solid #fca432;
            border-radius: 100%;
            display: block;
            box-shadow: 0 0 2px 0 rgb(0 0 0 / 44%);
          }
          .example-thumb.active {
            background-color: grey;
          }
          .example-track {
            position: relative;
            background: #ddd;
          }
          .example-track.example-track-0 {
            background: #fca432;
          }
          .horizontal-slider .example-track {
            top: 15px;
            height: 5px;
          }
          .horizontal-slider .example-thumb {
            top: 12px;
            width: 10px;
            outline: none;
            height: 10px;
            line-height: 38px;
          }
        `}
      </style>
    </>
  );
};

export default CompanyDetail;
